import { Box, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeOverflowMenuIfOpen, setFullScreen } from "../../../../toolbox/actions.web";
import Icon from "../../../../base/icons/components/Icon";
import { IconCheck } from "../../../../base/icons/svg";
import { useTranslation } from "react-i18next";
const ScaleScreen = ({ classes, cx, handleClose }) => {
    const { fullScreen } = useSelector((state) => state['features/toolbox']);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const handleClick = () => {
        dispatch(closeOverflowMenuIfOpen());
        dispatch(setFullScreen(!fullScreen));
        handleClose();
    };
    return (React.createElement(Box, { className: classes.borderTop },
        React.createElement(Box, { className: cx(classes.itemPopover, fullScreen ? `${classes.choosen}` : ''), onClick: handleClick },
            React.createElement(Box, { sx: {
                    '& svg': {
                        height: '22px',
                        width: '22px'
                    }
                } },
                React.createElement(Icon, { size: 24, src: IconCheck, color: fullScreen ? 'white' : 'transparent' })),
            React.createElement(Typography, { className: classes.textItem }, t('dialog.layout.scaleUp')))));
};
export default ScaleScreen;
